import { Component, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { UsersService } from 'src/app/domains/users/services';
import { User } from 'src/app/domains/users/models';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-add-user-popup',
  templateUrl: './add-user-popup.component.html',
  styleUrls: ['./add-user-popup.component.scss']
})
export class AddUserPopupComponent {
  public user: User;
  public companyId: number;
  public loading: boolean = false;
  @Output() onAddUser: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private activeModal: NgbActiveModal,
    private usersService: UsersService,
    private notification: NotificationService) {}

  addUser(event: User) {
    this.loading = true;
    if(!this.user._isEditing) {
      this.usersService.addUser(this.companyId, event,
        [
          {
            status: 400,
            message: 'company.user.add-popup.error'
          }
        ])
        .pipe(switchMap(r => {
          if (event.password !== null) {
            return this.usersService.activateUser({
              email: event.email,
              newPassword1: event.password,
              newPassword2: event.password,
            });
          } else {
            return of(r);
          }
        }))
        .subscribe(
          (res: any) => {
            this.onAddUser.emit();
            this.loading = false;
            this.close();
          }, () => {
            this.close();
          });
    }
  }

  close() {
    this.activeModal.close();
  }
}
